import { lazyImport, LoginTypes } from '@procom-labs/common'
import { ProcessAuthReturn } from '@procom-labs/organisms'

import {
  AplinBullhornResume,
  CustomStaffingBullhornResume,
  GorillaWorksBullhornResume,
  IMethodsBullhornResume,
  NewburyBullhornResume,
  ProcomBullhornResume,
} from '@resume-portal/features/resume-builder/routes'

import { AccessDenied } from './access-denied'
import { PrivacyPolicy } from './privacy-policy'
import { CommonRoutesPaths } from './routes.enum'
import { TermsOfUse } from './terms-of-use'

const { BullhornAtsResumeBuilder } = lazyImport(
  () =>
    import(
      '@resume-portal/features/resume-builder/components/builder/bullhorn-ats'
    ),
  'BullhornAtsResumeBuilder'
)

export const commonRoutes = [
  {
    path: '/auth-return',
    element: (
      <ProcessAuthReturn
        loginType={LoginTypes.GorillaResume}
        defaultRoute={CommonRoutesPaths.Parse}
      />
    ),
  },
  {
    path: CommonRoutesPaths.BullhornParse,
    element: <BullhornAtsResumeBuilder />,
  },
  {
    path: CommonRoutesPaths.AccessDenied,
    element: <AccessDenied />,
  },
  {
    path: CommonRoutesPaths.PrivacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: CommonRoutesPaths.TermsOfUse,
    element: <TermsOfUse />,
  },
  {
    path: CommonRoutesPaths.ProcomBullhornResumeBuilder,
    element: <ProcomBullhornResume />,
  },
  {
    path: CommonRoutesPaths.IMethodsBullhornResumeBuilder,
    element: <IMethodsBullhornResume />,
  },
  {
    path: CommonRoutesPaths.CustomStaffingBullhornResumeBuilder,
    element: <CustomStaffingBullhornResume />,
  },
  {
    path: CommonRoutesPaths.NewburyBullhornResumeBuilder,
    element: <NewburyBullhornResume />,
  },
  {
    path: CommonRoutesPaths.AplinBullhornResumeBuilder,
    element: <AplinBullhornResume />,
  },
  {
    path: CommonRoutesPaths.GorillaWorksBullhornResumeBuilder,
    element: <GorillaWorksBullhornResume />,
  },
]
